import { createContext, useContext, useState } from "react";
import useSWR from "swr";
import { fetchData } from "../../lib/dashboard/data";
import { sendData } from "../../lib/dashboard/actions";

const GlobalMarketSpreadPriceContext = createContext();

const GlobalMarketSpreadPriceProvider = ({ children }) => {
  const [inputValues1, setInputValues1] = useState({
    industry: null,
    commodityType: null,
    commodity: null,
    transitType: null,
  });
  const [inputValues2, setInputValues2] = useState({
    industry: null,
    commodityType: null,
    commodity: null,
    transitType: null,
  });
  const [chartData, setChartData] = useState({ data: [], isLoading: false });
  const [isFavoritesModal, setIsFavoritesModal] = useState(false);

  const { data: favorites, isValidating: isFavoritesValidation } = useSWR(
    "/favorite/global-favorite-ratio-chart",
    fetchData,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const industries1 = useSWR("/global-market/industry", fetchData, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  const commodityTypes1 = useSWR(
    inputValues1.industry
      ? `/global-market/commodity-type/${inputValues1.industry.id}`
      : null,
    fetchData,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const commodities1 = useSWR(
    inputValues1.commodityType
      ? `/global-market/commodity/${inputValues1.commodityType.id}`
      : null,
    fetchData,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const transitTypes1 = useSWR(
    inputValues1.commodity
      ? `/global-market/transit/${inputValues1.commodity.id}`
      : null,
    fetchData,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const industries2 = useSWR("/global-market/industry", fetchData, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  const commodityTypes2 = useSWR(
    inputValues2.industry
      ? `/global-market/commodity-type/${inputValues2.industry.id}`
      : null,
    fetchData,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const commodities2 = useSWR(
    inputValues2.commodityType
      ? `/global-market/commodity/${inputValues2.commodityType.id}`
      : null,
    fetchData,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const transitTypes2 = useSWR(
    inputValues2.commodity
      ? `/global-market/transit/${inputValues2.commodity.id}`
      : null,
    fetchData,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const handleShowChart = async (body) => {
    setChartData((prev) => ({ ...prev, isLoading: true }));
    const { status, data } = await sendData(body, "/global-market/ratio-chart");
    if (status === 200) setChartData((prev) => ({ ...prev, data }));
    setChartData((prev) => ({ ...prev, isLoading: false }));
  };

  return (
    <GlobalMarketSpreadPriceContext.Provider
      value={{
        industries1,
        commodityTypes1,
        commodities1,
        transitTypes1,
        inputValues1,
        industries2,
        commodityTypes2,
        commodities2,
        transitTypes2,
        inputValues2,
        setInputValues1,
        inputValues2,
        setInputValues2,
        isFavoritesModal,
        setIsFavoritesModal,
        favorites,
        isFavoritesValidation,
        chartData: chartData.data,
        setChartData,
        isLoadingChart: chartData.isLoading,
        handleShowChart,
      }}
    >
      {children}
    </GlobalMarketSpreadPriceContext.Provider>
  );
};

export default GlobalMarketSpreadPriceProvider;

export const useGlobalMarketSpreadPriceContext = () =>
  useContext(GlobalMarketSpreadPriceContext);
